import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Typography,
  CircularProgress,
  Button,
  DialogTitle,
  DialogContent,
  Dialog,
  DialogActions,
  Grid,
  TextField,
  Box,
  FormControlLabel,
  Radio,
  Divider,
  Checkbox,
  Link,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import I18n from '../../config/locales';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { isEmpty, isEqual, uniq, values } from 'lodash';
import AddSystemSection from '../../components/CreateSystem/addSystemSection';
import SnakBar from '../../components/SnakBar';
import { createSystem, getSearchResult, getSiteDetails } from './actions';
import {
  AUSTRALIA_COUNTRY_CODE,
  PROJECT_TYPES,
  SYSTEM_CREATION_TYPES,
} from './constants';
import { getToken, setToken } from '../../utils/helper';
import {
  isCommercial,
  isDRSService,
  isPermitService,
  isExisting,
  isNA,
  isNew,
  isResidential,
} from './helper';
import scrollIntoView from 'scroll-into-view';
import { getValue } from '../../utils/localStorage';
import getConfig from '../../config/env';

const style = theme => ({
  dialogHeader: {
    color: '#335977',
    fontSize: '29px',
    fontWeight: 'Bold',
  },
  close: {
    position: 'absolute',
    right: theme.spacing(3.5),
    top: theme.spacing(3),
    opacity: 0.23,
    cursor: 'pointer',
    fontSize: theme.spacing(3.5),
  },
  content: {
    padding: theme.spacing(2.5),
    color: '#2C2C2C !important',
  },
  paperContent: {
    border: '1px solid #7070704D',
    padding: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(2.5, 0),
  },
  radioInputField: {
    width: 'auto',
  },
  dialogRejectButton: {
    color: '#70707081',
    background: theme.palette.secondary.main,
  },
  acceptButton: {
    color: theme.palette.primary.white,
  },
  autoCompleteField: {
    maxWidth: theme.spacing(55),
    marginTop: theme.spacing(1),
  },
  termsAccepted: {
    marginTop: theme.spacing(3),
  },
  actionContainer: {
    padding: theme.spacing(2.5),
    justifyContent: 'flex-start',
  },
  alreadyLinkedMessage: {
    color: theme.palette.primary.main,
  },
  dialogHeaderMain: {
    borderBottom: '2px solid #70707033',
  },
  systemRadio: {
    width: 'auto',
    marginRight: '10%',
  },
  systemSelectionText: {
    fontWeight: 'bold',
    letterSpacing: theme.spacing(0.025),
    paddingLeft: theme.spacing(0.5),
  },
  systemContainer: {
    paddingBottom: theme.spacing(2),
  },
  disableSection: {
    pointerEvents: 'none',
    opacity: 0.5,
  },
  courseSelect: {
    minWidth: '40%',
  },
  applyForCC: {
    marginTop: theme.spacing(1.375),
  },
});

const StyledDialog = withStyles({
  root: {
    zIndex: '700 !important',
  },
})(Dialog);

class CreateSystem extends React.Component {
  constructor(props) {
    super(props);
    this.detailsPrefilled = false;
    this.timeout = null;
    this.state = { ...this.initializeState() };
  }

  componentDidMount() {
    setToken(this.props.enlmToken);
    this.props.getSearchResult({
      searchValue: '_ALL_SITES_',
      searchType: 'all_stages',
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.detailsPrefilled) {
      this.detailsPrefilled = true;
      if (!isEmpty(this.props.address)) {
        this.setState({ address: this.props.address });
      }
      if (!isEmpty(this.props.owner)) {
        this.setState({ owner: this.props.owner });
      }
      if (!isEmpty(this.props.projectType)) {
        const source = isResidential(this.props.projectType)
          ? 1
          : isCommercial(this.props.projectType)
            ? 2
            : '';
        this.setState({
          system: { ...this.state.system, source },
          showCheckbox: source === 1,
        });
      }
    }
    if (
      isResidential(this.state.systemType) &&
      this.state.applyForCC &&
      !isEmpty(this.props.allowedCourseIds) &&
      prevState.selectedCourseId === '' &&
      this.props.allowedCourseIds.length === 1
    ) {
      this.setState({
        selectedCourseId: Object.keys(this.props.allowedCourseIds[0])[0],
      });
    }
  }

  initializeState = () => {
    return {
      anyErrors: false,
      errors: {
        street1: false,
        city: false,
        state: false,
        country: false,
        postal_code: false,
        first_name: false,
        last_name: false,
        email: false,
        phone: false,
        system_name: false,
        source: false,
        expected_pcu_count: false,
      },
      selectedType: '',
      address: {
        street1: '',
        street2: '',
        city: '',
        state: '',
        country: '',
        postal_code: '',
      },
      owner: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
      },
      system: {
        system_name: '',
        source: '',
        is_lease: false,
        expected_pcu_count: '',
        installer: '',
        operational: '',
      },
      googleAddress: {},
      isConfirmChecked: false,
      isExpanded: true,
      isInValidEmail: false,
      isInValidPhone: false,
      searchValue: '',
      selectedSite: {},
      systemType: PROJECT_TYPES.RESIDENTIAL,
      applyForCC: true,
      showCheckbox: true,
      systemLinkInProgress: false,
      siteVerification: false,
      termsAgreed: false,
      siteTypeMismatch: false,
      selectedCourseId: '',
    };
  };

  handleClosePopup = () => {
    this.setState({ ...this.initializeState() });
    this.detailsPrefilled = false;
    this.props.handleClose();
  };

  setOwnerInfo = (e, key, validate = true) => {
    const value = e.target.value;
    const newOwner = { ...this.state.owner };
    newOwner[key] = value;
    this.setState({ owner: newOwner });
    if (validate) {
      const errors = this.getErrors(key, value);
      const anyErrors = this.anyErrors(errors);
      this.setState({ errors, anyErrors });
    }
  };

  setSystemInfo = (e, key, validate = true, isCheckbox = false) => {
    const value = isCheckbox ? e.target.checked : e.target.value;
    const newSystem = { ...this.state.system };
    newSystem[key] = value;
    this.setState({ system: newSystem });
    if (validate) {
      const errors = this.getErrors(key, value);
      const anyErrors = this.anyErrors(errors);
      this.setState({ errors, anyErrors });
    }
  };

  setAddressInfo = (value, key, validate = true) => {
    const newAddress = { ...this.state.address };
    newAddress[key] = value;
    this.setState({ address: newAddress });
    if (validate) {
      const errors = this.getErrors(key, value);
      const anyErrors = this.anyErrors(errors);
      this.setState({ errors, anyErrors });
    }
  };

  setAddress = newAddress => {
    const newErrors = { ...this.state.errors };
    newErrors.street1 = false;
    newErrors.city = false;
    newErrors.state = false;
    newErrors.country = false;
    newErrors.postal_code = false;
    const anyErrors = this.anyErrors(newErrors);
    this.setState({ address: newAddress, errors: newErrors, anyErrors });
  };

  proceedSubmit = async () => {
    this.setState({ systemLinkInProgress: true });
    const {
      selectedType,
      system,
      address,
      owner,
      selectedSite,
      selectedCourseId,
    } = this.state;
    const { service, companyId } = this.props;
    if (isExisting(selectedType) && selectedSite.id) {
      let payload = {
        siteId: selectedSite.id,
        selectedCourseId: this.state.applyForCC ? selectedCourseId : '',
        type: this.state.systemType,
      };
      if (isDRSService(service)) payload.termsAccepted = this.state.termsAgreed;
      this.props.linkSystem(payload);
      this.handleClosePopup();
      return;
    }
    if (isNew(selectedType)) {
      const errors = this.getErrors('', '');
      const anyErrors = this.anyErrors(errors);
      if (anyErrors) {
        this.setState(
          { errors, anyErrors, isExpanded: true, systemLinkInProgress: false },
          () => {
            let firstErrorKey = '';
            Object.keys(this.state.errors).forEach(key => {
              if (this.state.errors[key] && isEmpty(firstErrorKey)) {
                firstErrorKey = key;
              }
            });
            if (!isEmpty(firstErrorKey)) {
              scrollIntoView(document.getElementById(firstErrorKey));
            }
          }
        );
      } else {
        const systemType =
          system.source === 1
            ? PROJECT_TYPES.RESIDENTIAL.toLowerCase()
            : system.source === 2
              ? PROJECT_TYPES.COMMERCIAL.toLowerCase()
              : PROJECT_TYPES.OTHER.toLowerCase();
        const systemPayload = {
          ...system,
          system_type: systemType,
          installer: companyId,
          address,
          owner,
        };
        await this.props.createSystem({
          system: systemPayload,
          successCbk: response => {
            let payload = {
              siteId: response.system_id,
              selectedCourseId: this.state.applyForCC ? selectedCourseId : '',
              type: this.state.systemType,
            };
            if (isDRSService(service)) {
              payload.termsAccepted = this.state.termsAgreed;
            }
            this.props.linkSystem(payload);
            this.handleClosePopup();
          },
          failureCbk: () => {
            this.setState({ systemLinkInProgress: false });
          },
        });
      }
    } else if (isNA(selectedType)) {
      const payload = {
        selectedCourseId: this.state.applyForCC ? selectedCourseId : '',
        type: this.state.systemType,
      };
      if (isDRSService(service)) {
        payload.termsAccepted = this.state.termsAgreed;
      }
      this.props.linkSystem(payload);
      this.setState({ systemLinkInProgress: false });
    }
  };

  getErrors = (key, value) => {
    const { service, countryCode } = this.props;
    let newErros = { ...this.state.errors };
    const emailCheck = emailValue => {
      if (isEmpty(emailValue === null ? '' : emailValue.toString())) {
        this.setState({ isInValidEmail: false });
        return true;
      } else {
        const emailFormat =
          /^(([^<>()\[\]\\.,;:\u00C0-\u00FF\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,10}))$/;
        const localIsValidEmail = (emailValue === null) ? '' : emailValue;
        const isValidEmail = localIsValidEmail.match(emailFormat);
        this.setState({ isInValidEmail: !isValidEmail });
        return !isValidEmail;
      }
    };
    const phoneCheck = phoneValue => {
      if (isEmpty(phoneValue === null ? '' : phoneValue.toString())) {
        this.setState({ isInValidPhone: false });
        return true;
      } else {
        const localPhoneValue = (phoneValue === null) ? '' : phoneValue.toString();
        const isInValidPhone =
          isDRSService(service) && isEqual(countryCode, AUSTRALIA_COUNTRY_CODE)
            ? localPhoneValue.length < 8 && localPhoneValue.length > 10
            : localPhoneValue.length !== 10;
        this.setState({ isInValidPhone });
        return isInValidPhone;
      }
    };

    if (key === '') {
      Object.keys(newErros).forEach(allKey => {
        const data = {
          ...this.state.address,
          ...this.state.system,
          ...this.state.owner,
        };
        if (allKey === 'email') {
          newErros[allKey] = emailCheck(data[allKey]);
        } else if (allKey === 'phone') {
          newErros[allKey] = phoneCheck(data[allKey]);
        } else {
          newErros[allKey] = isEmpty(
            data[allKey] === null ? '' : data[allKey].toString()
          );
        }
      });
    } else if (key === 'email') {
      newErros[key] = emailCheck(value);
    } else if (key === 'phone') {
      newErros[key] = phoneCheck(value);
    } else {
      newErros[key] = isEmpty(value === null ? '' : value.toString());
    }
    return newErros;
  };

  anyErrors = (newErrors = this.state.errors) => {
    const errorValues = uniq(values(newErrors));
    return errorValues.length === 1 ? errorValues[0] === true : true;
  };

  handleSiteSearch = event => {
    if (event) {
      const newValue = event.target.value;
      clearTimeout(this.timeout);
      this.setState({ searchValue: newValue || '' });
      if (newValue && newValue.length > 0) {
        this.timeout = setTimeout(() => {
          this.props.getSearchResult({
            searchValue: newValue || '',
            searchType: 'all_stages',
          });
        }, 1000);
      } else {
        this.props.getSearchResult({
          searchValue: '_ALL_SITES_',
          searchType: 'all_stages',
        });
      }
    }
  };

  siteSelection = (e, selectedSite) => {
    if (selectedSite) {
      if (isDRSService) {
        this.siteTypeCheck(selectedSite);
      } else {
        this.setState({
          selectedSite: selectedSite,
          searchValue: selectedSite.label,
        });
      }
      if (this.props.onSiteChange) {
        this.setState({ siteVerification: true });
        this.props.onSiteChange({
          siteId: selectedSite.id,
          cbk: () => this.setState({ siteVerification: false }),
        });
      }
    } else {
      this.setState({ selectedSite: '' });
    }
  };

  changeSystemType = type => {
    const source = type === PROJECT_TYPES.RESIDENTIAL ? 1 : 2;
    this.setState({
      systemType: type,
      system: { ...this.state.system, source: source },
      showCheckbox: source === 1,
      siteTypeMismatch: false,
      selectedSite: {},
      searchValue: '',
      selectedCourseId: '',
    });
  };

  siteTypeCheck(selectedSite) {
    this.setState({ siteTypeMismatch: false }, () => {
      this.props.getSiteDetails({
        siteId: selectedSite.id,
        successCbk: siteDetails => {
          var siteType =
            siteDetails.site_type === 1
              ? PROJECT_TYPES.RESIDENTIAL
              : PROJECT_TYPES.COMMERCIAL;
          if (siteType === this.state.systemType) {
            this.setState({
              selectedSite: selectedSite,
              searchValue: selectedSite.label,
              siteTypeMismatch: false,
            });
          } else {
            this.setState({
              siteTypeMismatch: true,
              selectedSite: {
                ...selectedSite,
                siteType,
              },
              searchValue: selectedSite.label,
            });
          }
        },
        failureCbk: () => { },
      });
    });
  }

  render() {
    const {
      viewLinkSiteDialog,
      headerName,
      proceedButtonText,
      classes,
      siteSearchInProgress,
      linkSiteInProgress,
      canLinkSystem,
      service,
      allowedCourseIds,
      searchResults = [],
      linkSiteMessage = '',
      appliedSiteIds = [],
      message,
      messageType,
      currentlySending,
      countryCode,
    } = this.props;

    const {
      address,
      owner,
      system,
      selectedType,
      isConfirmChecked,
      errors,
      isExpanded,
      isInValidEmail,
      isInValidPhone,
      searchValue,
      applyForCC,
      showCheckbox,
      systemType,
      selectedSite = {},
      systemLinkInProgress,
      siteTypeMismatch = false,
    } = this.state;

    const isDRS = isDRSService(service);
    const isPermit = isPermitService(service);
    const showSystemLink = isDRS
      ? canLinkSystem || systemType === PROJECT_TYPES.COMMERCIAL
      : true;
    const cantLinkSystem =
      isDRS && !canLinkSystem && systemType !== PROJECT_TYPES.COMMERCIAL;
    const showCheckBox =
      isDRS &&
      !isEmpty(allowedCourseIds) &&
      showCheckbox &&
      (canLinkSystem || systemType === PROJECT_TYPES.COMMERCIAL);

    const getCountryList = () => {
      switch (countryCode) {
        case AUSTRALIA_COUNTRY_CODE:
          return [['createSystem.australia', 'AU']];
        case 'US':
          return [['createSystem.usa', 'US']];
        case 'DE':
          return [['createSystem.germany', 'DE']];
        case 'BE':
          return [['createSystem.belgium', 'BE']];
        case 'AT':
          return [['createSystem.austria', 'AT']];
        case 'NL':
          return [['createSystem.netherlands', 'NL']];
        case 'FR':
          return [['createSystem.france', 'FR']];
        case 'CH':
          return [['createSystem.switzerland', 'CH']];
        default:
          return [['createSystem.usa', 'US']];
      }
    };

    const getAgreedForTermsText = () => {
      return (
        <Typography>
          {I18n.t('createSystem.agreedForTerms1')}{' '}
          <Link href={this.props.termsLink}>
            {I18n.t('createSystem.termsAndCondition')}
          </Link>{' '}
          {I18n.t('createSystem.agreedForTerms2')}
        </Typography>
      );
    };

    const countryList = getCountryList();

    return (
      <Fragment>
        <StyledDialog
          onClose={this.handleClosePopup}
          aria-labelledby="system-dialog-title"
          open={viewLinkSiteDialog}
          id="system-dialog"
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            id="system-dialog-title"
            onClose={this.handleClosePopup}
            className={classes.dialogHeaderMain}
          >
            <Typography className={classes.dialogHeader}>
              {headerName}
              <CloseIcon
                onClick={this.handleClosePopup}
                className={classes.close}
                size="large"
              />
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.content}>
            {isDRS && (
              <Box className={classes.systemContainer}>
                <Typography className={classes.systemSelectionText}>
                  {I18n.t('createSystem.selectSystem')}
                </Typography>
                <Box className={classes.systemType}>
                  <FormControlLabel
                    className={classes.systemRadio}
                    value={PROJECT_TYPES.RESIDENTIAL}
                    control={
                      <Radio
                        color="primary"
                        size="medium"
                        classes={{ padding: 0 }}
                        onClick={() =>
                          this.changeSystemType(PROJECT_TYPES.RESIDENTIAL)
                        }
                        checked={isResidential(systemType)}
                        disabled={false}
                      />
                    }
                    label={I18n.t('createSystem.residential')}
                  />
                  {isDRS &&
                    (isEqual(countryCode, AUSTRALIA_COUNTRY_CODE) ||
                      isEqual(countryCode, 'US')) && (
                      <FormControlLabel
                        className={classes.systemRadio}
                        value={PROJECT_TYPES.COMMERCIAL}
                        control={
                          <Radio
                            color="primary"
                            size="medium"
                            classes={{ padding: 0 }}
                            onClick={() =>
                              this.changeSystemType(PROJECT_TYPES.COMMERCIAL)
                            }
                            checked={isCommercial(systemType)}
                          />
                        }
                        label={I18n.t('createSystem.commercial')}
                      />
                    )}
                </Box>
                {showCheckBox && (
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={applyForCC}
                          onChange={() =>
                            this.setState({
                              applyForCC: !this.state.applyForCC,
                              selectedCourseId: '',
                            })
                          }
                          disabled={!this.props.ensembleCertified}
                          name="ApplyForCC"
                          color="primary"
                        />
                      }
                      label={
                        <span style={{ color: '#000000' }}>
                          Create this application for
                        </span>
                      }
                      className={classes.applyForCC}
                    />
                    <FormControl className={classes.courseSelect}>
                      <InputLabel id="univCourse">Select</InputLabel>
                      <Select
                        className={classes.courseSelect}
                        id="univCourse"
                        labelId="univCourse"
                        value={this.state.selectedCourseId}
                        onChange={e => {
                          this.setState({ selectedCourseId: e.target.value });
                        }}
                        disabled={!applyForCC}
                      >
                        {this.props.allowedCourseIds.map(course => {
                          return (
                            <MenuItem
                              key={Object.keys(course)[0]}
                              value={Object.keys(course)[0]}
                            >
                              {Object.values(course)[0]}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Box>
            )}
            {cantLinkSystem && (
              <Typography>
                Please complete the pre-requisite training videos under{' '}
                <Link href="https://university.enphase.com/my/">
                  Enphase Storage Design courses
                </Link>{' '}
                in Enphase University to apply a design review of a residential
                system
              </Typography>
            )}
            {showSystemLink && (
              <Fragment>
                <Box className={classes.paperContent}>
                  <FormControlLabel
                    className={classes.radioInputField}
                    value={SYSTEM_CREATION_TYPES.EXISTING}
                    control={
                      <Radio
                        color="primary"
                        size="medium"
                        classes={{ padding: 0 }}
                        onClick={() =>
                          this.setState({
                            selectedType: SYSTEM_CREATION_TYPES.EXISTING,
                          })
                        }
                        checked={isExisting(this.state.selectedType)}
                      />
                    }
                    label={
                      <Typography>
                        {I18n.t('createSystem.selectfromList')}
                      </Typography>
                    }
                  />
                  <Autocomplete
                    autoComplete
                    noOptionsText={I18n.t('createSystem.noOption')}
                    className={classes.autoCompleteField}
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : option.label
                    }
                    filterOptions={x => x}
                    options={
                      searchResults.total_count ? searchResults.result : []
                    }
                    value={searchValue}
                    inputValue={searchValue}
                    getOptionSelected={(option, value) =>
                      option.label === value
                    }
                    getOptionDisabled={option =>
                      appliedSiteIds.includes(option.id)
                    }
                    onChange={this.siteSelection}
                    onInputChange={this.handleSiteSearch}
                    loading={siteSearchInProgress}
                    closeIcon={
                      isEmpty(searchValue) ? (
                        <Fragment />
                      ) : (
                        <CloseIcon fontSize="small" />
                      )
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        required
                        label={I18n.t('createSystem.enterSystemName')}
                      />
                    )}
                    renderOption={option => (
                      <Grid container alignItems="center">
                        <Grid item xs>
                          <Typography variant="body1" color="textPrimary">
                            {option.id} - {option.label}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                    disabled={!isExisting(this.state.selectedType)}
                  />
                  <br />
                  {linkSiteInProgress ||
                    (currentlySending && <CircularProgress size={15} />)}
                  {isDRS &&
                    this.state.siteTypeMismatch &&
                    selectedSite.siteType && (
                      <Typography
                        variant="caption"
                        className={classes.alreadyLinkedMessage}
                      >
                        {`${I18n.t(
                          'createSystem.siteSelectionErrorMsg1'
                        )}${I18n.t(
                          'createSystem.' +
                          selectedSite.siteType.toLowerCase() +
                          'ErrorMsg'
                        )}${I18n.t(
                          'createSystem.siteSelectionErrorMsg2'
                        )}${I18n.t(
                          'createSystem.' +
                          this.state.systemType.toLowerCase() +
                          'ErrorMsg'
                        )}${I18n.t('createSystem.siteSelectionErrorMsg3')}`}
                        <br />
                      </Typography>
                    )}
                  {linkSiteMessage.length > 0 && (
                    <Typography
                      variant="caption"
                      className={classes.alreadyLinkedMessage}
                    >
                      {linkSiteMessage}
                      <br />
                    </Typography>
                  )}
                </Box>
                <Divider variant="fullWidth" className={classes.divider} />
                <AddSystemSection
                  setAddressInfo={this.setAddressInfo}
                  setAddress={this.setAddress}
                  setOwnerInfo={this.setOwnerInfo}
                  setSystemInfo={this.setSystemInfo}
                  setSelectedType={() =>
                    this.setState({
                      selectedType: SYSTEM_CREATION_TYPES.NEW,
                      searchValue: '',
                      siteTypeMismatch: false,
                    })
                  }
                  address={address}
                  owner={owner}
                  system={system}
                  selectedType={selectedType}
                  errors={errors}
                  isConfirmChecked={isConfirmChecked}
                  isExpanded={isExpanded}
                  isInValidEmail={isInValidEmail}
                  isInValidPhone={isInValidPhone}
                  toggleExpansion={() =>
                    this.setState({ isExpanded: !this.state.isExpanded })
                  }
                  handleConfirmCheckedChange={() =>
                    this.setState({
                      isConfirmChecked: !this.state.isConfirmChecked,
                    })
                  }
                  countryList={countryList}
                  service={service}
                />
                <br />
                <Box className={classes.paperContent}>
                  <FormControlLabel
                    className={classes.radioInputField}
                    value={SYSTEM_CREATION_TYPES.NA}
                    control={
                      <Radio
                        color="primary"
                        size="medium"
                        classes={{ padding: 0 }}
                        onClick={() =>
                          this.setState({
                            selectedType: SYSTEM_CREATION_TYPES.NA,
                            searchValue: '',
                            siteTypeMismatch: false,
                          })
                        }
                        checked={isNA(this.state.selectedType)}
                      />
                    }
                    label={
                      <Fragment>
                        <Typography>
                          {I18n.t('createSystem.proceedCreateSystem')}
                        </Typography>
                        {isPermit && (
                          <Typography variant="caption">
                            Use this option to raise a permit assistance request
                            for Non-Enphase Products
                          </Typography>
                        )}
                      </Fragment>
                    }
                  />
                </Box>
                {isDRS && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.termsAgreed}
                        onChange={() =>
                          this.setState(prevState => {
                            return {
                              ...prevState,
                              termsAgreed: !prevState.termsAgreed,
                            };
                          })
                        }
                        name="agree"
                        color="primary"
                      />
                    }
                    label={getAgreedForTermsText()}
                    className={classes.termsAccepted}
                  />
                )}
              </Fragment>
            )}
          </DialogContent>
          <DialogActions className={classes.actionContainer}>
            <Button
              color="primary"
              variant="contained"
              disableElevation
              className={classes.acceptButton}
              disabled={
                cantLinkSystem ||
                (isNA(selectedType)
                  ? false
                  : isExisting(selectedType)
                    ? !selectedSite.id ||
                    this.state.siteVerification ||
                    siteTypeMismatch
                    : isNew(selectedType)
                      ? !isConfirmChecked
                      : true) ||
                systemLinkInProgress ||
                (isDRS && !this.state.termsAgreed) ||
                (isDRS &&
                  showCheckBox &&
                  !this.props.ensembleCertified &&
                  !this.state.selectedCourseId)
              }
              onClick={() => this.proceedSubmit()}
            >
              {proceedButtonText}
            </Button>
            {!systemLinkInProgress && (
              <Button
                onClick={this.handleClosePopup}
                className={classes.dialogRejectButton}
              >
                {I18n.t('createSystem.cancel')}
              </Button>
            )}
            {systemLinkInProgress && (
              <CircularProgress size={25} color="primary" />
            )}
          </DialogActions>
        </StyledDialog>
        {!currentlySending && message && messageType && (
          <SnakBar message={message} severity={messageType} />
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createSystem: payload => dispatch(createSystem(payload)),
  getSearchResult: payload => dispatch(getSearchResult(payload)),
  getSiteDetails: payload => dispatch(getSiteDetails(payload)),
});

const mapStateToProps = state => ({
  siteSearchInProgress: state.systemReducer.siteSearchInProgress,
  searchResults: state.systemReducer.searchResults,
  message: state.systemReducer.message,
  messageType: state.systemReducer.messageType,
  currentlySending: state.systemReducer.currentlySending,
  countryCode: state.defaultReducer.country,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(style)(CreateSystem));
